import React from 'react';
import * as S from './styles';
import { ThumbnailStackProps } from './types';

/**
 * Renders a visually stacked arrangement of thumbnails, with support for up to
 * three thumbnails. It dynamically adjusts the display based on the provided
 * source strings, ensuring that the first thumbnail in the list is always
 * displayed on the topmost layer.
 */
export const ThumbnailStack: React.FC<ThumbnailStackProps> = ({
  src,
  alt,
  ratio = 1,
  objectFit,
  className,
}) => {
  const thumbnailSrcList = typeof src === 'string' ? Array(3).fill(src) : src;

  return (
    <S.Root className={className}>
      {/* 
        Reverse the thumbnails list to ensure that the first image in the list 
        is rendered on the top layer, while subsequent thumbanails stack below it. 
        This preserves the natural ordering when layering images visually.
      */}
      {thumbnailSrcList?.reverse()?.map((thumbnailSrc) => (
        <S.StackedThumbnail
          src={thumbnailSrc}
          $ratio={ratio}
          $hasStack={thumbnailSrcList?.length > 1}
          basis={ratio < 1 ? 'height' : 'width'}
          {...{ ratio, objectFit, alt }}
        />
      ))}
    </S.Root>
  );
};

export default ThumbnailStack;
